import _ from "lodash";
import {DICTIONARY} from '../../../../dictionary';
import {GeneralService} from '../../../../services/generalService';
import {RouteService} from '../../../../services/routeService';
import {NotificationService} from '../../../../services/notificationService';
import {Component, OnInit, ViewChild} from "@angular/core";
import {ChartComponent} from "ng-apexcharts";
import {Router} from "@angular/router";
import {CollaborationProtectionService} from "../../../../services/collaborationProtectionService";
import util from "util";

@Component({
	selector: 'app-collaboration-overview',
	templateUrl: './collaboration-overview.component.html',
	styleUrls: ['./collaboration-overview.component.scss']
})
export class CollaborationOverviewComponent implements OnInit {
	dic = DICTIONARY;

	tabs = {
		environment: 'Environment',
		dlp: 'DLP',
		malicious: 'Malicious',
	};
	activeTab = this.tabs.environment;
	generateReportPopup;

	dashboardPeriod = [
		this.dic.CONSTANTS.trendsPeriod.lastDay,
		this.dic.CONSTANTS.trendsPeriod.last3Days,
		this.dic.CONSTANTS.trendsPeriod.lastWeek,
		this.dic.CONSTANTS.trendsPeriod.lastMonth,
	];
	config;

	threatKpiCards = [
		{icon: 'fas fa-shield-alt', color: '#7A5AF8', label: 'Threats Detected', value: 0},
		{icon: 'far fa-sitemap', color: '#0e9f8e', label: 'Malicious Resources', value: 0},
		{icon: 'far fa-comment-alt', color: '#7A5AF8', label: 'Malicious Messages', value: 0},
		{icon: 'far fa-file-alt', color: '#D92D20', label: 'Malicious Files', value: 0},
	];
	dlpKpiCards = [
		{icon: 'far fa-exclamation-triangle', color: '#e55353', label: 'Sensitive Data Findings', value: 0},
		{icon: 'far fa-sitemap', color: '#0e9f8e', label: 'Sensitive Resources', value: 0},
		{icon: 'far fa-comment-alt', color: '#2E90FA', label: 'Sensitive Messages', value: 0},
		{icon: 'far fa-file-alt', color: '#F79009', label: 'Sensitive Files', value: 0},
	];

	// Environment tab data
	envKpiCards = [
		{icon: 'far fa-users', color: '#486db5', label: 'Protected Users', value: '0'},
		{icon: 'far fa-sitemap', color: '#0e9f8e', label: 'Total Resources', value: '0'},
		{icon: 'fas fa-shield-alt', color: '#7A5AF8', label: 'Threats Detected', value: '0'},
		{icon: 'far fa-exclamation-triangle', color: '#e55353', label: 'Sensitive Data Findings', value: '0'},
	];
	resources: any[] = [];
	resourcesByType: any = {};
	mailboxes: any[] = [];
	envLoadingResources = false;
	envLoadingUsers = false;
	currentAssetInfoObj;
	currentResourceInfoObj;
	currentAssetsPopup;

	showLastScannedResourcesTips;
	showRecentFindingsTips;
	showSensitiveDataResourcesTips;
	showExternalSharedDataTips;
	showResourceBreakdownTips;
	showDlpSensitivityTypesTips;
	showThreatsBySourceTips;
	showThreatTypesTips;
	showTopDlpUsersTips;
	showTopTargetedUsersTips;
	showTopTargetedResourcesTips;

	sourceIcon(source: string) {
		if (source === 'Teams') return 'far fa-users';
		if (source === 'SharePoint') return 'far fa-globe';
		return 'far fa-cloud';
	}

	resourceTypeIcon(type: string) {
		switch (type) {
			case 'team': return 'far fa-users';
			case 'channel': return 'far fa-hashtag';
			case 'chat': return 'far fa-comment-dots';
			case 'site': return 'far fa-globe';
			case 'drive': case 'OneDrive': return 'far fa-hdd';
			case 'meeting': return 'far fa-video';
			default: return 'far fa-cube';
		}
	}

	resourceTypeLabel(type: string) {
		switch (type) {
			case this.dic.CONSTANTS.collaborationResourceType.team: return 'Teams';
			case this.dic.CONSTANTS.collaborationResourceType.channel: return 'Channels';
			case this.dic.CONSTANTS.collaborationResourceType.chat: return 'Chats';
			case this.dic.CONSTANTS.collaborationResourceType.site: return 'SharePoint Sites';
			case this.dic.CONSTANTS.collaborationResourceType.drive: return 'OneDrive';
			case this.dic.CONSTANTS.collaborationResourceType.meeting: return 'Meetings';
			default: return type;
		}
	}

	resourceTypeTooltip: Record<string, string> = {
		team: 'Microsoft Teams team — a workspace that brings together a group of people, content, and tools. A team can contain multiple channels and shared files.',
		channel: 'A channel within a Microsoft Teams team — a dedicated section for organizing conversations, files, and tabs around a specific topic or project.',
		chat: 'A private or group chat in Microsoft Teams — direct 1:1 or group messages between users, separate from team channels.',
		site: 'A SharePoint site — a web-based collaboration space used for document management, intranet portals, and team content. Each Teams team has a backing SharePoint site.',
		drive: 'A OneDrive or SharePoint document library — cloud storage for files and folders. OneDrive is personal storage; SharePoint drives are shared across teams and sites.',
		meeting: 'A Microsoft Teams meeting — a scheduled or ad-hoc audio/video conference. Meetings can have chat threads, shared files, and recordings.',
	};

	period = this.dic.CONSTANTS.trendsPeriod.lastMonth;
	assets;
	trendsInfo;
	trendsInfoRaw;
	getDataInProcess = false;
	usersFilterTypes = {all: 'all', specific: 'specific'};
	usersPopup;
	activeSpecificUsers;
	threatActivityTrendsChart;
	threatSourcePieChart;

	dlpSourcePieChart;
	dlpTrendsChart;
	dlpClassificationChart

	malwareTypesChart;

	envResourceBreakdown: any[] = [];
	recentScanResources: any[] = [];

	@ViewChild('threatActivityTrends', {static: false}) threatActivityTrends: ChartComponent;
	@ViewChild('threatSourcePie', {static: false}) threatSourcePie: ChartComponent;

	@ViewChild('dlpTrends', {static: false}) dlpTrends: ChartComponent;
	@ViewChild('dlpSourcePie', {static: false}) dlpSourcePie: ChartComponent;
	@ViewChild('classificationTypesChart', {static: false}) classificationTypesChart: ChartComponent;


	constructor(public gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService,
				private cps:CollaborationProtectionService,
				private router:Router) {
	}

	ngOnInit() {
		this.rs.getCollaborationConfiguration().then((response) => {
			this.config = response;
			this.getCollaborationResources();
			this.getCollaborationUsersMailboxes();
			this.getTrendsData(null);
		});
	}

	getCollaborationUsersMailboxes = () => {
		this.envLoadingUsers = true;

		this.rs.getCollaborationUsersMailboxes().then(response => {
			this.mailboxes = response || [];
			this.mailboxes.forEach((mailboxObj) => {
				mailboxObj.is_protected = mailboxObj.is_protected || this.config.collaboration_protection.microsoft?.protect_all;
			});
			const protectedCount = this.mailboxes.filter(u => u.is_protected).length;
			this.envKpiCards[0].value = protectedCount + '/' + this.mailboxes.length;
			this.envLoadingUsers = false;
		}, () => {
			this.envLoadingUsers = false;
		});
	}

	getCollaborationResources = () => {
		this.envLoadingResources = true;
		this.rs.getCollaborationResources().then(response => {
			this.resources = response || [];
			this.resourcesByType = {};
			this.resources.forEach(resourceObj => {
				this.cps.parseResourceName(resourceObj);
				const type = resourceObj.resource_type || 'other';
				if (!this.resourcesByType[type]) {
					this.resourcesByType[type] = [];
				}
				this.resourcesByType[type].push(resourceObj);
			});
			this.envKpiCards[1].value = String(this.resources.length);

			this.envResourceBreakdown = Object.keys(this.resourcesByType)
				.map(type => ({type, count: this.resourcesByType[type].length}))
				.sort((a, b) => b.count - a.count);

			// Build recent scan activity from resources with last_updated
			this.recentScanResources = this.resources
				.filter(r => r.last_updated)
				.sort((a, b) => new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime())
				.slice(0, 10);
			this.recentScanResources.forEach(r => this.parseRelativeTime(r, 'last_updated'));

			this.envLoadingResources = false;
		}, () => {
			this.envLoadingResources = false;
		});
	}

	changePeriod(period) {
		this.period = period;

		this.getTrendsData(null);
	}

	getTrendsData(range) {
		this.getDataInProcess = true;

		const params: any = {
			period: this.period.value
		};

		this.rs.getCollaborationTrends(params).then(response => {
			this.trendsInfoRaw = response;
			this.trendsInfoRaw.assets?.forEach(assetObj => {
				this.cps.parseResourceName(assetObj.resource_id);
				this.parseAssetDetails(assetObj);
			});

			this.processTrendsData();

			this.getDataInProcess = false;
		}, (err)=> {
			this.getDataInProcess = false;
		});
	}

	processTrendsData = () => {
		if (!this.trendsInfoRaw) {
			return;
		}

		this.trendsInfo = _.cloneDeep(this.trendsInfoRaw);
		if (this.activeSpecificUsers) {
			const selectedEmails = _.map(this.activeSpecificUsers, 'email');
			this.trendsInfo.assets = this.trendsInfo.assets.filter(assetObj =>
				selectedEmails.includes(assetObj.user)
			);
		}

		this.trendsInfo.collabStats = this.parseCollabStats(this.trendsInfo);

		this.prepareGeneralInfo(this.trendsInfo);

		this.prepareThreatActivityTrendsChart(this.trendsInfo.collabStats);
		this.prepareThreatSourcePieGraph();
		this.prepareMalwareTypesChart(this.trendsInfo.maliciousTypes);

		this.prepareDlpTrendsChart(this.trendsInfo.collabStats);
		this.prepareDlpSourcePieGraph();
		this.prepareDlpClassificationGraph(this.trendsInfo.classificationTypes);

		this.envKpiCards[2].value = String(this.threatKpiCards[2].value + this.threatKpiCards[3].value);
		this.envKpiCards[3].value = String(this.dlpKpiCards[0].value);
	}

	openUsersFilterPopup = () => {
		this.usersPopup = {
			type: this.activeSpecificUsers ? this.usersFilterTypes.specific : this.usersFilterTypes.all,
			users: this.activeSpecificUsers ? _.unionBy(this.activeSpecificUsers, _.cloneDeep(this.mailboxes), 'email') : _.cloneDeep(this.mailboxes),
			show: true
		};
	}

	applyUsersFilter = () => {
		if (this.usersPopup.type === this.usersFilterTypes.specific && !_.find(this.usersPopup.users, 'selected')) {
			this.ns.showErrorMessage('You must select at least one user');
			return;
		}

		if (this.usersPopup.type === this.usersFilterTypes.specific) {
			this.activeSpecificUsers = _.filter(this.usersPopup.users, 'selected');
		}
		else {
			this.activeSpecificUsers = null;
		}

		this.usersPopup = null;
		this.processTrendsData();
	}

	searchUser = (searchTerm) => {
		searchTerm = searchTerm.toLowerCase();
		this.usersPopup.users.forEach(record => {
			if (searchTerm) {
				const isFound = (record.email.toLowerCase().indexOf(searchTerm) > -1) ||
					(record.name?.toLowerCase().indexOf(searchTerm) > -1);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	}

	prepareGeneralInfo = (trends) => {

		this.threatKpiCards[1].value = 0;
		this.threatKpiCards[2].value = 0;
		this.threatKpiCards[3].value = 0;

		this.dlpKpiCards[0].value = 0;
		this.dlpKpiCards[2].value = 0;
		this.dlpKpiCards[3].value = 0;

		this.trendsInfo.threatsBySource = {
			total: 0,
			labels: ['Teams', 'OneDrive', 'SharePoint'],
			series: [0, 0, 0]
		};

		this.trendsInfo.dlpBySource = {
			total: 0,
			labels: ['Teams', 'OneDrive', 'SharePoint'],
			series: [0, 0, 0]
		};

		this.trendsInfo.maliciousTypes = {};

		this.trendsInfo.classificationTypes = {}; // name: counter
		this.trendsInfo.externalExposure = [];

		this.trendsInfo.topTargetedUsers = [];
		this.trendsInfo.topDlpUsers = [];
		this.trendsInfo.topDlpResources = [];

		this.trendsInfo.topMaliciousResources = [];

		trends.assets?.forEach((assetObj) => {
			this.parseGeneralAssetType(assetObj);
			this.parseTopDlpAndMaliciousMailboxes(assetObj);
			this.parseTopDlpResources(assetObj);
			this.parseTopMaliciousResources(assetObj);
		});

		this.threatKpiCards[0].value = this.threatKpiCards[2].value + this.threatKpiCards[3].value;

		this.dlpKpiCards[0].value = this.dlpKpiCards[2].value + this.dlpKpiCards[3].value;
		this.dlpKpiCards[1].value = this.trendsInfo.topDlpResources.length;

		this.trendsInfo.topTargetedUsers = this.trendsInfo.topTargetedUsers.sort((a, b) => b.hits - a.hits).slice(0, 10);
		this.trendsInfo.topDlpUsers = this.trendsInfo.topDlpUsers.sort((a, b) => b.hits - a.hits).slice(0, 10);
		this.trendsInfo.topDlpResources = this.trendsInfo.topDlpResources.sort((a, b) => b.hits - a.hits).slice(0, 10);

		this.trendsInfo.recentFindings = trends.assets.slice(-10).reverse();
	}

	parseCollabStats = (trendsInfo) => {

		const collabStats = {
			threatActivityStats: {
				total: 0,
				labels: [],
				data: [[], []],
				series: ['Files', 'Messages']
			},
			dlpStats: {
				total: 0,
				labels: [],
				data: [[], []],
				series: ['Files', 'Messages']
			}
		};

		let collabSourcePerPeriod: any = {};

		for (let i = 0; i < trendsInfo.assets?.length; i++) {
			const assetObj = trendsInfo.assets[i];

			if (!collabSourcePerPeriod.dateStart) {
				collabSourcePerPeriod = this.initCollabThreatSourcePerPeriod(assetObj, this.period);
			}

			if (this.gs.isSamePeriod(this.period, assetObj.created, collabSourcePerPeriod.dateEnd)) {
				if (assetObj.malicious_info) {
					collabStats.threatActivityStats.total += 1;
					if (assetObj.asset_type === 'message') {
						collabSourcePerPeriod.malicious_info.messages += 1;
					}
					else if (assetObj.asset_type === 'file') {
						collabSourcePerPeriod.malicious_info.files += 1;
					}
				}
				if (assetObj.sensitivity_info) {
					collabStats.dlpStats.total += 1;
					if (assetObj.asset_type === 'message') {
						collabSourcePerPeriod.sensitivity_info.messages += 1;
					}
					else if (assetObj.asset_type === 'file') {
						collabSourcePerPeriod.sensitivity_info.files += 1;
					}
				}
			}
			else {
				this.addCollaborationThreatGraphData(collabStats, collabSourcePerPeriod, this.period);
				collabSourcePerPeriod = this.initCollabThreatSourcePerPeriod(assetObj, this.period);

				if (assetObj.malicious_info) {
					collabStats.threatActivityStats.total += 1;
					if (assetObj.asset_type === 'message') {
						collabSourcePerPeriod.malicious_info.messages += 1;
					}
					else if (assetObj.asset_type === 'file') {
						collabSourcePerPeriod.malicious_info.files += 1;
					}
				}
				if (assetObj.sensitivity_info) {
					collabStats.dlpStats.total += 1;
					if (assetObj.asset_type === 'message') {
						collabSourcePerPeriod.sensitivity_info.messages += 1;
					}
					else if (assetObj.asset_type === 'file') {
						collabSourcePerPeriod.sensitivity_info.files += 1;
					}
				}
			}
		}

		this.addCollaborationThreatGraphData(collabStats, collabSourcePerPeriod, this.period);

		return collabStats;
	}


	prepareThreatActivityTrendsChart = (collabStats) => {

		const series = [];

		if (collabStats.threatActivityStats.labels?.length) {
			collabStats.threatActivityStats?.series?.forEach((categoryName, index) => {
				series.push({
					name: categoryName,
					data: collabStats.threatActivityStats.data[index]
				});
			});
		}


		this.threatActivityTrendsChart = {
			series: series,
			chart: {
				type: collabStats.threatActivityStats.labels?.length === 1 ? "bar" : "area",
				height: '100%',
				toolbar: {
					show: false
				},
				animations: {
					enabled: true,
				},
			},
			colors: ['#D92D20', '#7A5AF8'],
			dataLabels: {
				enabled: false
			},
			stroke: {
				show: true,
				width: 4,
				colors: ['transparent']
			},
			xaxis: {
				tickAmount: 4, // Set the maximum number of ticks (labels) to be displayed on the x-axis
				categories: collabStats.threatActivityStats.labels,
			},
			yaxis: {
				title: {
					text: 'Threats'
				}
			},
			fill: {
				opacity: 1
			},
			tooltip: {
				y: {
					formatter: (val) => {
						return val + ' threats';
					}
				}
			}
		};
	}

	prepareThreatSourcePieGraph = () => {
		const threatSourceLabels = this.trendsInfo.threatsBySource.labels;

		this.threatSourcePieChart = {
			series: this.trendsInfo.threatsBySource.series,
			chart: {
				type: 'donut',
				animations: {
					enabled: true,
				},
				events: {
					dataPointSelection: (event, chartContext, config) => {
						this.showResourceAssets(null, 'Malicious', null, threatSourceLabels[config.dataPointIndex]);
					}
				}
			},
			plotOptions: {
				pie: {
					donut: {
						size: '52%',
					}
				}
			},
			dataLabels: {
				enabled: true,
				formatter:  (val, opt) => {
					return opt.w.globals.series[opt.seriesIndex];
				}
			},
			colors: ['#6264A7', '#0078D4', '#038387'],
			labels: this.trendsInfo.threatsBySource.labels,
			tooltip: {
				y: {
					formatter:  (val) => {
						return val + ' threats';
					}
				}
			}
		};
	}

	prepareMalwareTypesChart = (maliciousTypes) => {
		// @ts-ignore
		const sortedTypes = Object.fromEntries(Object.entries(maliciousTypes).sort((a, b) => b[1] - a[1]));
		const sortedTypesArray = Object.entries(sortedTypes).map(([type, count]) => ({ type, count }));

		const series = [];
		const labels = [];
		for (let i = 0; i < sortedTypesArray.length && i < 10; i++) {
			series.push(sortedTypesArray[i].count);
			labels.push(sortedTypesArray[i].type);
		}

		this.malwareTypesChart = {
			series,
			chart: {
				type: 'donut', animations: {enabled: true},
				events: {
					dataPointSelection: (event, chartContext, config) => {
						this.showResourceAssets(null, 'Malicious', labels[config.dataPointIndex]);
					}
				}
			},
			plotOptions: {pie: {donut: {size: '52%'}}},
			dataLabels: {enabled: true, formatter: (val, opt) => opt.w.globals.series[opt.seriesIndex]},
			colors: ['#D92D20', '#F79009', '#7A5AF8', '#2E90FA', '#0e9f8e', '#486db5', '#e55353', '#94a3b8'],
			labels,
		};
	}

	prepareDlpSourcePieGraph = () => {

		this.dlpSourcePieChart = {
			series: this.trendsInfo.dlpBySource.series,
			chart: {
				type: 'donut',
				animations: {
					enabled: true,
				},
				events: {
					dataPointSelection: (event, chartContext, config) => {
						this.showResourceAssets(null, 'DLP', null, this.trendsInfo.dlpBySource.labels[config.dataPointIndex])
					}
				}
			},
			plotOptions: {
				pie: {
					donut: {
						size: '52%',
					}
				}
			},
			dataLabels: {
				enabled: true,
				formatter:  (val, opt) => {
					return opt.w.globals.series[opt.seriesIndex];
				}
			},
			colors: ['#6264A7', '#0078D4', '#038387'],
			labels: this.trendsInfo.dlpBySource.labels,
			tooltip: {
				y: {
					formatter:  (val) => {
						return val + ' DLP';
					}
				}
			}
		};
	}

	prepareDlpClassificationGraph = (classificationTypes) => {

		// @ts-ignore
		const sortedTypes = Object.fromEntries(Object.entries(classificationTypes).sort((a, b) => b[1] - a[1]));
		const sortedTypesArray = Object.entries(sortedTypes).map(([type, count]) => ({ type, count }));

		const series = [];
		const labels = [];
		for (let i = 0; i < sortedTypesArray.length && i < 7; i++) {
			series.push(sortedTypesArray[i].count);
			labels.push(sortedTypesArray[i].type);
		}

		this.dlpClassificationChart = {
			series,
			chart: {
				type: 'pie',
				height: '100%',
				events: {
					dataPointSelection: (event, chartContext, config) => {
						this.showResourceAssets(null, 'DLP', labels[config.dataPointIndex])
					}
				}
			},
			colors: this.gs.chartColors,
			labels: labels,
			plotOptions: {
				pie: {
					donut: {
						size: '52%',
					}
				}
			},
		};
	}


	prepareDlpTrendsChart = (collabStats) => {

		const series = [];

		if (collabStats.dlpStats.labels?.length) {
			collabStats.dlpStats?.series?.forEach((categoryName, index) => {
				series.push({
					name: categoryName,
					data: collabStats.dlpStats.data[index]
				});
			});
		}


		this.dlpTrendsChart = {
			series: series,
			chart: {
				type: collabStats.dlpStats.labels?.length === 1 ? "bar" : "area",
				height: '100%',
				toolbar: {
					show: false
				},
				animations: {
					enabled: true,
				},
			},
			colors: ['#F79009', '#2E90FA'],
			dataLabels: {
				enabled: false
			},
			stroke: {
				show: true,
				width: 4,
				colors: ['transparent']
			},
			xaxis: {
				tickAmount: 4, // Set the maximum number of ticks (labels) to be displayed on the x-axis
				categories: collabStats.dlpStats.labels,
			},
			yaxis: {
				title: {
					text: 'DLP'
				}
			},
			fill: {
				opacity: 1
			},
			tooltip: {
				y: {
					formatter: (val) => {
						return val + ' DLP';
					}
				}
			}
		};
	}


	initCollabThreatSourcePerPeriod(emailObj, period) {
		const collabSourcePerPeriod = this.gs.calcDatesForPeriod(emailObj, period);
		collabSourcePerPeriod.malicious_info = {
			files: 0,
			messages: 0
		};
		collabSourcePerPeriod.sensitivity_info = {
			files: 0,
			messages: 0
		};

		return collabSourcePerPeriod;
	}

	addCollaborationThreatGraphData(collabStats, collabSourcePerPeriod, period) {
		if (collabSourcePerPeriod.dateStart) {
			const dateLabel = this.gs.getPeriodLabel(period, collabSourcePerPeriod);

			collabStats.threatActivityStats.labels.push(dateLabel);
			collabStats.threatActivityStats.data[0].push(collabSourcePerPeriod.malicious_info.files);
			collabStats.threatActivityStats.data[1].push(collabSourcePerPeriod.malicious_info.messages);

			collabStats.dlpStats.labels.push(dateLabel);
			collabStats.dlpStats.data[0].push(collabSourcePerPeriod.sensitivity_info.files);
			collabStats.dlpStats.data[1].push(collabSourcePerPeriod.sensitivity_info.messages);
		}
	}


	parseGeneralAssetType = (assetObj) => {
		if (assetObj.malicious_info) {
			this.trendsInfo.threatsBySource.total++;
			switch (assetObj.asset_type) {
				case 'message':
					this.threatKpiCards[2].value++;
					this.trendsInfo.threatsBySource.series[0]++;
					break;

				case 'file':
					this.threatKpiCards[3].value++;
					this.trendsInfo.threatsBySource.series[1]++;
					break;
			}
		}

		if (assetObj.sensitivity_info) {
			this.trendsInfo.dlpBySource.total++;
			switch (assetObj.asset_type) {
				case 'message':
					this.dlpKpiCards[2].value++;
					this.trendsInfo.dlpBySource.series[0]++;
					break;

				case 'file':
					this.dlpKpiCards[3].value++;
					this.trendsInfo.dlpBySource.series[1]++;
					break;
			}
		}
	}

	parseTopDlpAndMaliciousMailboxes = (assetObj) => {
		if (assetObj.user) {
			if (assetObj.malicious_info) {
				const existing = this.trendsInfo.topTargetedUsers.find(u => u.email === assetObj.user);
				if (existing) {
					existing.hits++;
				} else {
					this.trendsInfo.topTargetedUsers.push({email: assetObj.user, hits: 1});
				}
			}
			else if (assetObj.sensitivity_info) {
				const existing = this.trendsInfo.topDlpUsers.find(u => u.email === assetObj.user);
				if (existing) {
					existing.hits++;
				}
				else {
					this.trendsInfo.topDlpUsers.push({email: assetObj.user, hits: 1});
				}

				if (assetObj.permissions?.link?.scope === 'anonymous'/* || assetObj.resource_id.external_members?.length*/) {
					this.trendsInfo.externalExposure.push(assetObj);
				}
			}
		}
	}

	parseTopDlpResources = (assetObj) => {

		if (!assetObj.sensitivity_info) {
			return;
		}

		assetObj.sensitivity_info.sensitive_types.forEach((sensitiveTypeObj) => {
			if (sensitiveTypeObj.score) {
				if (!this.trendsInfo.classificationTypes[sensitiveTypeObj.sensitive_type]) {
					this.trendsInfo.classificationTypes[sensitiveTypeObj.sensitive_type] = 0;
				}
				this.trendsInfo.classificationTypes[sensitiveTypeObj.sensitive_type]++;
			}
		});

		if (assetObj.resource_id) {
			const existing = this.trendsInfo.topDlpResources.find(u => u.id === assetObj.resource_id._id);
			if (existing) {
				existing.hits++;
			}
			else {
				const source = assetObj.asset_type === 'message' ? 'Teams' : 'OneDrive';
				this.trendsInfo.topDlpResources.push({
					resource_id: assetObj.resource_id,
					name: assetObj.resource_id?.name, id: assetObj.resource_id._id, hits: 1, source
				});
			}
		}
	}

	parseTopMaliciousResources = (assetObj) => {

		if (!assetObj.malicious_info) {
			return;
		}

		assetObj.malicious_info.sub_status?.forEach((subStatusObj) => {
			if (!this.trendsInfo.maliciousTypes[subStatusObj.sub_status]) {
				this.trendsInfo.maliciousTypes[subStatusObj.sub_status] = 0;
			}
			this.trendsInfo.maliciousTypes[subStatusObj.sub_status]++;
		});

		if (assetObj.resource_id) {
			const existing = this.trendsInfo.topMaliciousResources.find(u => u.id === assetObj.resource_id._id);
			if (existing) {
				existing.hits++;
			}
			else {
				this.threatKpiCards[1].value++;
				const source = assetObj.asset_type === 'message' ? 'Teams' : 'OneDrive';
				this.trendsInfo.topMaliciousResources.push({
					resource_id: assetObj.resource_id,
					name: assetObj.resource_id?.name, id: assetObj.resource_id._id, hits: 1, source
				});
			}
		}
	}

	showAssetActionsInPopup = (assetObj) => {
		return ['View info'];
	}

	selectAssetActionInPopup = (assetObj, action) => {
		switch (action) {
			case 'View info':
				this.currentAssetInfoObj = assetObj;
				break;
		}
	}

	showAssetsPopup = (userEmail, category) => {
		this.currentAssetsPopup = {
			name: userEmail,
			assets: this.trendsInfo.assets.filter(assetObj => assetObj.category === category && assetObj.user === userEmail),
			show: true
		};
	}

	showResourceAssets = (resourceObj, category=null, type=null, source=null) => {
		const assets = this.trendsInfo.assets.filter(assetObj => {
			// by id
			if (resourceObj && assetObj.resource_id?._id !== resourceObj.id) {
				return false;
			}

			// by category
			if (category && assetObj.category !== category) {
				return false;
			}

			// by type
			if (type && assetObj.sensitivity_info) {
				const sensitivityTypes = (assetObj.sensitivity_info.sensitive_types || []).filter(t => t.score).map(t => t.sensitive_type);
				if (!sensitivityTypes.includes(type)) {
					return false;
				}
			}
			if (type && assetObj.malicious_info) {
				const maliciousThreatTypes = (assetObj.malicious_info.sub_status || []).map(t => t.sub_status);
				if (!maliciousThreatTypes.includes(type)) {
					return false;
				}
			}

			// by source
			if (source) {
				const assetSource = assetObj.asset_type === 'message' ? 'Teams' : 'OneDrive';
				if (assetSource !== source) {
					return false;
				}
			}

			return true;
		})

		this.currentAssetsPopup = {
			name: type || source || resourceObj?.name,
			assets,
			show: true
		};
	}

	sensitivityScoreColor(score: number) {
		if (score >= 5) return '#FF4136';
		if (score >= 4) return '#FF851B';
		if (score >= 1) return 'darkorange';
		return 'limegreen';
	}

	linkScopeTooltips: Record<string, string> = {
		anonymous: 'Anyone with the link can access (no login required)',
		organization: 'Anyone in your organization with the shared link can access this file',
		users: 'Only users with existing access (must sign in)',
		external: 'At least one or more external user has an access to this file'
	};

	goToResources = (options?) => {
		this.router.navigate(
			[this.dic.CONSTANTS.appStates.collaborationProtection, this.dic.CONSTANTS.adminPages.collaborationProtection.users, this.dic.CONSTANTS.collaborationProtectionUsersTabs.resources],
			{state: {data: options}}
		);
	}

	getVisibleTabIndex(tabName: string): number {
		return Object.entries(this.tabs)
			.map(([, value]) => value)
			.indexOf(tabName);
	}

	generateReportAction = () => {
		this.generateReportPopup = {
			show: true,
			range: {start: new Date(Date.now() - (1000 * 60 * 60 * 24 * 7)), end: new Date() },
			reportAddress: '',

			updateReportSettings: () => {
				const actionInfo = {
					action: 'reportSettings',
					type: this.dic.CONSTANTS.reportActions.settings,
					data: this.config.collaboration_protection.scheduled_reports
				};
				this.rs.configureCollaborationPolicy(actionInfo).then(() => {
					this.generateReportPopup.inProcess = false;
					this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
				}, () => {
					this.generateReportPopup.inProcess = false;
				});
			},

			getReport: () => {
				if (this.generateReportPopup.range.start > Date.now() || this.generateReportPopup.range.start > this.generateReportPopup.range.end) {
					this.ns.showErrorMessage(this.dic.ERRORS.adminReportDate)
					return;
				}

				this.gs.showPopup({
					title: 'Generate Report',
					subTitle: 'You are about to generate a report. Once this is finished, the report will be sent to your email address.',
					type: this.dic.CONSTANTS.popupInfo,
					doneBtnText: 'Generate',
					doneCb: () => {
						this.generateReportPopup.inProcess = true;
						const params = {range: this.generateReportPopup.range};
						this.rs.getCollaborationReport(params).then(() => {
							this.ns.showInfoMessage('Report operation started successfully');
							this.generateReportPopup.inProcess = false;
						}, (err) => {
							this.generateReportPopup.inProcess = false;
						});
					}
				});
			}
		};
	};

	addReportAddress(address) {
		if (!address || this.generateReportPopup?.inProcess) {
			return;
		}

		address = address.trim().toLowerCase();
		if (this.config.collaboration_protection.scheduled_reports.addresses.find(itm => itm === address)) {
			this.ns.showErrorMessage(util.format(this.dic.ERRORS.itemAlreadyExist, address));
			return;
		}

		this.generateReportPopup.inProcess = true;

		const actionInfo = {
			action: 'reportSettings',
			type: this.dic.CONSTANTS.reportActions.emails,
			data: {
				email: address,
				type: this.dic.CONSTANTS.actions.add
			}
		};
		this.rs.configureCollaborationPolicy(actionInfo).then(() => {
			this.config.collaboration_protection.scheduled_reports.addresses.push(address);
			this.generateReportPopup.reportAddress = '';
			this.generateReportPopup.inProcess = false;
		}, () => {
			this.generateReportPopup.inProcess = false;
		});
	}

	deleteReportAddress(address) {
		if (!address || this.generateReportPopup?.inProcess) {
			return;
		}

		address = address.toLowerCase();
		if (!this.config.collaboration_protection.scheduled_reports.addresses.find(itm => itm === address)) {
			return;
		}

		this.generateReportPopup.inProcess = true;

		const actionInfo = {
			action: 'reportSettings',
			type: this.dic.CONSTANTS.reportActions.emails,
			data: {
				email: address,
				type: this.dic.CONSTANTS.actions.delete
			}
		}
		this.rs.configureCollaborationPolicy(actionInfo).then(() => {
			this.config.collaboration_protection.scheduled_reports.addresses = this.config.collaboration_protection.scheduled_reports.addresses.filter(item => item !== address);
			this.generateReportPopup.inProcess = false;
		}, () => {
			this.generateReportPopup.inProcess = false;
		});
	}

	parseRelativeTime = (obj, dateField) => {
		const d = new Date(obj[dateField]);
		const diff = Date.now() - d.getTime();
		const mins = Math.floor(diff / 60000);
		if (mins < 1) {
			obj.relativeTime = 'just now';
		}
		else if (mins < 60) {
			obj.relativeTime = mins + 'm ago';
		}
		else {
			const hours = Math.floor(mins / 60);
			if (hours < 24) {
				obj.relativeTime = hours + 'h ago';
			}
			else {
				const days = Math.floor(hours / 24);
				if (days < 30) {
					obj.relativeTime = days + 'd ago';
				}
				else {
					obj.relativeTime = Math.floor(days / 30) + 'mo ago';
				}
			}
		}
		const pad = (n) => String(n).padStart(2, '0');
		obj.createdLabel = pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
	}

	parseAssetDetails = (assetObj) => {
		if (assetObj.created) {
			this.parseRelativeTime(assetObj, 'created');
		}

		if (assetObj.sensitivity_info) {
			assetObj._topSensitiveTypes = (assetObj.sensitivity_info.sensitive_types || [])
				.filter(t => t.score)
				.sort((a, b) => (b.score || 0) - (a.score || 0))
				.slice(0, 3)
				.map(t => t.sensitive_type);
		}

		if (assetObj.malicious_info) {
			assetObj._maliciousSubCategory = (assetObj.malicious_info.sub_status || [])
				.map(s => s.message)
				.slice(0, 2);
		}
	}
}
